import * as React from 'react';
import Button from '@mui/material/Button';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {getCanceleds} from '../../NewProcess/apiRequestService';
import ShowGrid from '../../ui/ShowGrid'
import CanceledDetailPage from './DetailPage';
import styles from '../../../style.js';
import {styleForHeader, styleForAvatar} from '../../../style.js';
import {styleDownloadFileBtn} from '../../ui/ShowGrid/component';
import RejectedDetailPage from '../Rejected/DetailPage';
import TimeoutDetailPage from '../Timeout/DetailPage';

const CANCELED_STATUS = 'İptal Edilen';
const REJECTED_STATUS = 'Reddedilen';
const TIMEOUT_STATUS = 'Zaman Aşımı';

class Canceled extends React.Component{
  constructor(props){
      super(props);
      this.state = {
          data: [],
          columns : [
            { field: 'id', width: 100, sortable: false,  headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader(''),
                renderCell: (params) => this.styleShowDetailBtn(params.value)
            },  
            { field: 'name', width: 250, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('SÜREÇ ADI')
            },
            { field: 'signOrder', width: 200, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('İMZALAMA SIRASI')
            },
            { field: 'sufficientSigner', width: 150, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('İMZACI SAYISI')
            },         
            { field: 'status', width: 150, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('DURUM')
            },
            { field: 'createdDate', width: 200, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('TARİH')
            },    
            { field: 'participant', width: 200, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('KATILIMCI'),
                renderCell: (params) => styleForAvatar(params.row.signerInfo)
            },     
            { field: 'downloadFile', width: 200, sortable: false,  headerAlign:'center', align:'center',
            renderHeader: () => styleForHeader(''),
            renderCell: (params) => styleDownloadFileBtn(params.row.id, params.row.status)
            }   
        ],
          selectedIds:[],
          editPage: false,
          selectedId:0,
          isLoaded:false
        }
  }


  styleShowDetailBtn = (value) => {
    const onClick = (e) => {
      e.stopPropagation();

      this.SelectRow(value);
    };

    return <Button onClick={onClick} style={styles.showButton} variant="contained" > Göster</Button>   
  }

  showGridRowClick = (params) => {
    this.SelectRow(params.row.id,params.row.status);
  };

  SelectRow(value,status){
    if (status == CANCELED_STATUS) {
      this.setState({editPage:true,selectedId:value,status:CANCELED_STATUS});
    }  
    else if (status == REJECTED_STATUS) {
    this.setState({ editPage: true, selectedId: value, status: REJECTED_STATUS });
    }
    else if (status == TIMEOUT_STATUS) {
      this.setState({ editPage: true, selectedId: value, status: TIMEOUT_STATUS });
    }
  }

  refreshList(){
    getCanceleds()
    .then((response) => {
      this.setState({ data: response.data});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Onay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getWaitings exception: ' + JSON.stringify(exception));
    })
    .finally(()=>{
      this.setState({ isLoaded: true});
    });
    
  }

  componentDidMount() {   
    this.refreshList();
  }

  closeEditPage = () => {
    this.setState({ 
      editPage: false});

      this.refreshList();
  };

  render(){
      const {data,columns,editPage,isLoaded,status} = this.state;

      let selectedDetailPage = null;
      if (editPage) {
        switch(status) {
          case CANCELED_STATUS:
            selectedDetailPage = <CanceledDetailPage open = {editPage} {...this.props} {...this.state} closeEditPage={this.closeEditPage}/>;
            break;
          case REJECTED_STATUS:
            selectedDetailPage = <RejectedDetailPage open={editPage} {...this.props} {...this.state} closeEditPage={this.closeEditPage} />;
            break;
            case TIMEOUT_STATUS:
              selectedDetailPage = <TimeoutDetailPage open={editPage} {...this.props} {...this.state} closeEditPage={this.closeEditPage} />;
              break;
          default:
            selectedDetailPage = null;
        }
      }
      
      return (
        <div>
          <div>
            {!editPage && isLoaded ?<ShowGrid data={data} columns={columns} handleRowClick={this.showGridRowClick}/>:null}
          </div>
          <div>
          {selectedDetailPage}
          </div>
        </div>
        
      );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(Canceled);